import React from "react";
import { Grid } from "@mui/material";
import TopNavBar from "../../Components/TopBar/Navbar";

const TermsAndConditions = () => {
  return (
    <Grid
      container
      sm={12}
      xs={12}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"flex-start"}
      className="leaderboard_page"
    >
      <Grid container position={"fixed"} zIndex={100}>
        <TopNavBar />
      </Grid>
      <Grid lg={6}  style={{ marginTop: "7%",alignItems:"center",alignContent:"center" }}>
        `
        <Grid className="p-2" lg={10} marginTop={{lg:"0%",md:"0%",sm:"7%",xs:"7%"}} >
          {" "}
          <h1 style={{ textAlign: "center" }}>Terms And Conditions</h1>{" "}
        </Grid>
        <Grid className=" p-2" >
          <p>
          The OpenZK network and protocol is a non-custodial and semi-permissioned online digital platform, allowing certain smart contracts to be deployed and run on its blockchain under certain conditions; it is not a financial or payment service of any kind and in any jurisdiction. The terms “earn”, “deposit”, “bridge”, “stake” and other similar wording found in this website or in any herein accessible digital application are used only as a basic reference, without any effective or legal meaning of the same terms in a regulated and/or financial environment. The OZK token is the core utility token of OpenZK and is not structured as nor intended to be a security or a financial product in any jurisdiction, nor actively marketed in any specific location. 

Certain OpenZK protocol features may be inaccessible or unusable for users residing in certain Countries, territories and jurisdictions. While OpenZK strives to achieve a safe and secure digital environment, there are no guarantees of merchantability or fitness for any use and OpenZK is provided “as is”, disclaiming any liability whatsoever.{" "}
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TermsAndConditions;
